import React from 'react';
import LessonHome from '../LessonHome';

const Lesson5 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson5;